import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';

import { useAssignDesignOutputDesignInput } from '../Product.hooks';
import {
  ProductDesignInput,
  BaseProductAssignDialogProps
} from '../Product.interface';
import AssignDesignInputDialog from './AssignDesignInputDialog';

export type DesignOutputAssignDesignInputDialogProps = BaseProductAssignDialogProps<'designOutputId'>;

const DesignOutputAssignDesignInputDialog: React.FC<DesignOutputAssignDesignInputDialogProps> = (
  props: DesignOutputAssignDesignInputDialogProps
) => {
  const {
    open,
    productId,
    designOutputId,
    selectedItems,
    onCancel,
    onError,
    onAssigned
  } = props;
  const {
    updatedProductDesignOutput,
    isAssigning,
    error: assignError,
    assignDesignInputs
  } = useAssignDesignOutputDesignInput(productId, designOutputId);

  // handle notification to parent after assigning
  useEffect(() => {
    if (updatedProductDesignOutput) {
      onAssigned?.(updatedProductDesignOutput);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedProductDesignOutput]);

  useEffect(() => {
    if (assignError) {
      onError?.(assignError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignError]);

  return (
    <AssignDesignInputDialog
      {...{ open, productId, selectedItems, onCancel, onError }}
      isLoading={isAssigning}
      contentText={`Search for ${getProductEntityName(
        'designInput'
      )} to assign to the ${getProductEntityName('designOutput')}.`}
      onSubmit={(designInputs: ProductDesignInput[]) => {
        assignDesignInputs({
          designInputIds: designInputs.map(
            (designInput: ProductDesignInput) => designInput.id
          )
        });
      }}
    />
  );
};

export default DesignOutputAssignDesignInputDialog;
